export default __webpack_public_path__ + "static/kele-f5fb9033f9b799897f9d0f65321bdc3a.png";